import { supabase } from '../lib/supabase';
import { User, Session } from '@supabase/supabase-js';

interface AuthResponse {
  data: { user: User | null; session: Session | null };
  error: Error | null;
}

export const authService = {
  async signIn(email: string, password: string): Promise<AuthResponse> {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: { user: null, session: null }, error: error as Error };
    }
  },

  async signUp(
    email: string,
    password: string,
    metadata?: {
      fullName?: string;
      phone?: string;
      role?: 'customer' | 'practitioner';
    }
  ): Promise<AuthResponse> {
    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            full_name: metadata?.fullName || '',
            phone: metadata?.phone || '',
            role: metadata?.role || 'customer',
          },
        },
      });
      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: { user: null, session: null }, error: error as Error };
    }
  },

  async signOut(): Promise<{ error: Error | null }> {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      return { error: null };
    } catch (error) {
      return { error: error as Error };
    }
  },

  async getSession(): Promise<{ data: { session: Session | null }; error: Error | null }> {
    try {
      const { data, error } = await supabase.auth.getSession();
      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: { session: null }, error: error as Error };
    }
  },

  async getUser(): Promise<{ data: { user: User | null }; error: Error | null }> {
    try {
      const { data, error } = await supabase.auth.getUser();
      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: { user: null }, error: error as Error };
    }
  },

  async getUserProfile(userId: string) {
    try {
      const { data, error } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('id', userId)
        .single();
      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error: error as Error };
    }
  },
};